var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"details_section"},[_c('h4',{staticClass:"details_section--header text-uppercase"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }